import React from "react";
import { FileText, Youtube } from "lucide-react";

/** Student-facing Media Library — PDFs + embedded YouTube videos for a course. */
export function ResourcesPanel({ resources }) {
  if (!resources || resources.length === 0) {
    return <p className="text-sm text-slate-500 text-center py-8" data-testid="resources-panel-empty">No extra resources for this course yet.</p>;
  }
  return (
    <div className="space-y-4" data-testid="resources-panel">
      {resources.map((r) => (
        <div key={r.id} className="bg-white/[0.03] border border-white/10 rounded-xl p-4" data-testid={`resource-card-${r.id}`}>
          <p className="text-sm font-semibold text-white flex items-center gap-2 mb-2.5">
            {r.type === "pdf" ? <FileText className="w-4 h-4 text-rose-300" /> : <Youtube className="w-4 h-4 text-red-400" />} {r.title}
          </p>
          {r.type === "pdf" ? (
            <a href={r.url} target="_blank" rel="noreferrer" data-testid={`resource-pdf-link-${r.id}`}
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:text-primary/80 bg-primary/10 px-3 py-1.5 rounded-lg">
              <FileText className="w-3.5 h-3.5" /> Open PDF
            </a>
          ) : (
            <div className="aspect-video rounded-lg overflow-hidden">
              <iframe
                src={`https://www.youtube.com/embed/${r.youtube_id}`} title={r.title} className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                data-testid={`resource-youtube-embed-${r.id}`}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
